const initialState = true;

export const setIsHideVideo = (state, { payload }) => payload;

export default initialState;
